import { render, staticRenderFns } from "./multiRouterAndPrint.vue?vue&type=template&id=c271d812&"
import script from "./multiRouterAndPrint.vue?vue&type=script&lang=js&"
export * from "./multiRouterAndPrint.vue?vue&type=script&lang=js&"
import style0 from "./multiRouterAndPrint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c271d812')) {
      api.createRecord('c271d812', component.options)
    } else {
      api.reload('c271d812', component.options)
    }
    module.hot.accept("./multiRouterAndPrint.vue?vue&type=template&id=c271d812&", function () {
      api.rerender('c271d812', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/multiRouterAndPrint.vue"
export default component.exports